import request from '@/utils/request'
/*权限*/
let AuthApi = {
  /*获取当前角色权限*/
  getRoleList(data) {
    return request._post('/shop/auth.user/getRoleList', data);
  },
  /*获取角色信息*/
  getUserInfo(data) {
    return request._post('/shop/auth.user/getUserInfo', data);
  },
  getNewOrders() {
    return request._post('/shop/auth.user/getNewOrders');
  },
  /*角色列表*/
  roleList(data) {
    return request._post('/shop/auth.role/index', data);
  },
  /*添加角色需要的数据*/
  roleAddInfo(data) {
    return request._get('/shop/auth.role/add', data);
  },
  /*添加角色*/
  roleAdd(data) {
    return request._post('/shop/auth.role/add', data);
  },
  /*修改角色需要的数据*/
  roleEditInfo(data) {
    return request._get('/shop/auth.role/edit', data);
  },
  /*修改角色*/
  roleEdit(data) {
    return request._post('/shop/auth.role/edit', data);
  },
  /*删除角色*/
  roleDelete(data) {
    return request._post('/shop/auth.role/delete', data);
  },

  /*管理员列表*/
  userList(data) {
    return request._post('/shop/auth.user/index', data);
  },
  /*添加管理员需要的数据*/
  userAddInfo(data) {
    return request._post('/shop/auth.user/addInfo', data);
  },
  /*添加管理员*/
  userAdd(data) {
    return request._post('/shop/auth.user/add', data);
  },
 /*修改管理员需要的数据*/
  userEditInfo(data) {
    return request._get('/shop/auth.user/edit', data);
  },
  /*修改管理员*/
  userEdit(data) {
    return request._post('/shop/auth.user/edit', data);
  },
  /*删除管理员*/
  userDelete(data) {
    return request._post('/shop/auth.user/delete', data);
  },
  /*登录日志*/
  loginlog(data) {
    return request._post('/shop/auth.loginlog/index', data);
  },
  /*操作日志*/
  optlog(data) {
    return request._post('/shop/auth.optlog/index', data);
  }
}
export default AuthApi;



// WEBPACK FOOTER //
// ./src/api/auth.js